<template>
  <tabs parent="communication_management">
    <tab id="actions_history" name="Simcard actions history" :href="url+'actions_history'" >
      <ActionsHistory />
    </tab>

    <tab id="tariffs" name="Operator Tariffs" :href="url+'tariffs'" >
      <Tariffs />
    </tab>

    <tab id="operators_api" name="Operators API" :href="url+'operators_api'" >
      <OperatorsAPI />
    </tab>

    <tab id="sim_server" name="RemoteSim Servers" :href="url+'sim_server'" >
      <SimServer />
    </tab>

    <tab id="remote_sims" name="RemoteSims" :href="url+'remote_sims'" >
      <RemoteSims />
    </tab>

    <tab id="intersect" v-if="false" :name="translate('simcard_profile.section.list-intersect')" :href="url+'intersect'" >
      <CommunicationManagementIndex request="intersect" />
    </tab>

    <tab id="not_use" v-if="false" :name="translate('simcard_profile.section.list-not-use')" :href="url+'not_use'">
      <CommunicationManagementIndex request="not_use" />
    </tab>

    <tab id="anothers" v-if="false" :name="translate('simcard_profile.section.list-anothers')" :href="url+'anothers'">
      <CommunicationManagementIndex request="anothers" />
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import CommunicationManagementIndex from './CommunicationManagementIndex.vue'
import Tariffs from './Tariffs.vue'
import ActionsHistory from './ActionsHistory.vue'
import OperatorsAPI from './OperatorsAPI.vue'
import SimServer from './SimServer.vue'
import RemoteSims from './RemoteSims.vue'

export default {
  name: 'CommunicationManagement',
  components:{
    Tab,
    Tabs,
    CommunicationManagementIndex,
    Tariffs,
    ActionsHistory,
    OperatorsAPI,
    SimServer,
    RemoteSims
  },
  props: {
    dev_id: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      load: true,
      simcards: [],
      tariffs: [],
    }
  },
  computed: {
    url () { return '/communication_management/' }
  },

}
</script>
